export default [
  {
    inputs: [],
    name: 'isDirectCollateralEnabled',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
    ],
    name: 'isCollateralTokenEnabled',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
    ],
    name: 'getCollateralOracleConfig',
    outputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'oracle',
            type: 'address',
          },
          {
            internalType: 'bool',
            name: 'enabled',
            type: 'bool',
          },
        ],
        internalType: 'struct IAnyCollateralConfig.CollateralOracleConfig',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'collateralToken',
        type: 'address',
      },
    ],
    name: 'getCollateralOpenCap',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'maxOpenAmount',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'usedOpenAmount',
            type: 'uint256',
          },
        ],
        internalType: 'struct IAnyCollateralConfig.CollateralOpenCap',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
] as const;
